import UniversalRouter from 'universal-router';
import routes from './routes';

export const router = new UniversalRouter(routes, {
  baseUrl: ''
});
